(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.fund-report.event
  (:require
   [clojure.edn :as edn]
   [common.util :as cu]
   [frontend.controller.websocket.event :as ws]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.sub :as sub]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::text-save-ok
 (fn [{_db :db} [_ _resp]] 
   (js/console.log "SAVE OK")))

(rf/reg-event-fx
 ::text-save-failed
 (fn [{_db :db} [_ resp]]
   (js/console.log "Text save failed " resp)))


(rf/reg-event-fx
 ::save-fund-report-text
 (fn [{db :db}
      [_ fund-report-id dynamic-path new-value
       complete-path complete-status]]
   (let [rich-content-list (get-in db sub/rich-content-list-path) 
         fund-report-new-list (->> rich-content-list
                                   (mapv (fn [rich-content-map]
                                           (if (= (:rich-content-completed-path rich-content-map) complete-path)
                                             (assoc rich-content-map
                                                    :completed? (not (cu/blank-value? complete-status))
                                                    :rich-content-completed-at complete-status
                                                    :rich-content new-value)
                                             rich-content-map))))]
     {:db (cond-> db
            dynamic-path
            (assoc-in (into [] (concat [:lp-report-editor :lp-report :lp-report/editable-data]
                                       dynamic-path)) new-value)
            complete-path
            (assoc-in (into [] (concat [:lp-report-editor :lp-report :lp-report/editable-data]
                                       complete-path)) complete-status)
            (not= rich-content-list fund-report-new-list)
            (assoc-in sub/rich-content-list-path fund-report-new-list))
      ::ws/send {:id         :lp-report/update-text
                 :body       {:report-id       fund-report-id
                              :value-path      dynamic-path
                              :new-value       new-value
                              :complete-path   complete-path
                              :complete-status complete-status}
                 :on-success [::text-save-ok]
                 :on-error   [::text-save-failed]}})))

(rf/reg-event-fx
 ::image-save-ok
 (fn [{_db :db} [_ _resp]]
   (js/console.log "SAVE OK")))

(rf/reg-event-fx
 ::image-save-failed
 (fn [{_db :db} [_ resp]]
   (js/console.log "Image save failed " resp)))

(rf/reg-event-fx
 ::save-fund-report-image
 (fn [{db :db}
      [_ fund-report-id dynamic-path new-value
       complete-path complete-status]]
   {:db (cond-> db
          dynamic-path
          (assoc-in (into [] (concat [:lp-report-editor :lp-report :lp-report/editable-report-images]
                                     dynamic-path)) new-value)
          complete-path
          (assoc-in (into [] (concat [:lp-report-editor :lp-report :lp-report/editable-report-images]
                                     complete-path)) complete-status))
    ::ws/send {:id         :lp-report/update-report-image
               :body       {:report-id       fund-report-id
                            :value-path      dynamic-path
                            :new-value       new-value
                            :complete-path   complete-path
                            :complete-status complete-status}
               :on-success [::image-save-ok]
               :on-error   [::image-save-failed]}}))

(rf/reg-event-fx
 ::save-fund-report-image-to-s3-ref-ok
 (fn [{db :db}
      [_ attachment-id attachment-download-url resp]]
   (let [{:keys [value-path new-value complete-path complete-status]} (:body resp)]
     {:db (cond-> db
            value-path
            (assoc-in (into [] (concat [:lp-report-editor :lp-report :lp-report/editable-report-images]
                                       value-path))
                      new-value)
            (and attachment-id attachment-download-url)
            (assoc-in [:lp-report-editor :images attachment-id]
                      {:db/id        attachment-id
                       :download-url attachment-download-url})
            complete-path
            (assoc-in (into [] (concat [:lp-report-editor :lp-report :lp-report/editable-report-images]
                                       complete-path))
                      complete-status))})))

(rf/reg-event-fx
 ::save-fund-report-image-to-s3-ref
 (fn [{_db :db}
      [_ fund-report-id dynamic-path attachment-id attachment-download-url complete-path complete-status]]
   {::ws/send {:id         :lp-report/set-report-image
               :body       {:report-id       fund-report-id
                            :value-path      dynamic-path
                            :attachment-id   attachment-id
                            :complete-path   complete-path
                            :complete-status complete-status}
               :on-success [::save-fund-report-image-to-s3-ref-ok attachment-id attachment-download-url]
               :on-error   [::image-save-failed]}}))

(rf/reg-event-fx
 ::upload-fund-report-image-to-s3-ok
 (fn [{_db :db}
      [_ fund-report-id dynamic-path complete-path complete-status resp]]
   (let [attachment-id (get-in resp [:body :attachment-id])
         download-url (get-in resp [:body :download-url])]
     {:fx [[:dispatch [::save-fund-report-image-to-s3-ref
                       fund-report-id
                       dynamic-path
                       attachment-id
                       download-url
                       complete-path
                       complete-status]]]})))

(rf/reg-event-fx
 ::upload-fund-report-image-to-s3-failed
 (fn [{_db :db} [_ resp]]
   (js/console.log "Report image S3 upload failed " resp)))

(rf/reg-event-fx
 ::save-fund-report-image-to-s3
 (fn [{_db :db}
      [_ fund-report-id dynamic-path new-value complete-path complete-status]]
   (if (cu/blank-value? new-value)
     {:fx [[:dispatch [::save-fund-report-image-to-s3-ref
                       fund-report-id
                       dynamic-path
                       nil
                       nil
                       complete-path
                       complete-status]]]}
     {::ws/send {:id         :lp-report/upload-report-image
                 :body       {:report-id fund-report-id
                              :data      new-value
                              :filename  (str (name (last dynamic-path)) ".png")}
                 :on-success [::upload-fund-report-image-to-s3-ok
                              fund-report-id
                              dynamic-path
                              complete-path
                              complete-status]
                 :on-error   [::upload-fund-report-image-to-s3-failed]}})))

(rf/reg-event-fx
  ::table-save-ok
  (fn [{db :db} [_ on-success! _editable-path resp]]
    (when (fn? on-success!)
      (on-success!))
    (let [updated-state (-> resp
                            :body)
          new-state (if (string? updated-state)
                      (edn/read-string updated-state)
                      updated-state)]
      (when new-state
        {:db (-> db
                 (assoc-in [:lp-report-editor :lp-report :lp-report/editable-data] new-state))}))))

(rf/reg-event-fx
  ::table-save-failed
  (fn [{_db :db} [_ _fund-report-id resp]]
    (js/console.log "Text save failed " resp)))

(rf/reg-event-fx
  ::save-fund-report-table-data
  (fn [{db :db}
       [_ fund-report-id on-success! dynamic-path new-value]]
    (let [editable-path (into [] (concat [:lp-report-editor :lp-report :lp-report/editable-data]
                                         dynamic-path))]
    {:db       (assoc-in db
                         ;; optimistic save
                         editable-path
                         new-value)
     ::ws/send {:id         :lp-report/update-table
                :body       {:report-id       fund-report-id
                             :value-path      dynamic-path
                             :new-value       new-value}
                :on-success [::table-save-ok on-success! editable-path]
                :on-error   [::table-save-failed fund-report-id]}})))

(rf/reg-event-fx
 ::chart-configs-save-ok
 (fn [{db :db} [_ on-success! _editable-path resp]]
   (when (fn? on-success!)
     (on-success!))
   (let [updated-state (-> resp
                           :body)
         new-state (if (string? updated-state)
                     (edn/read-string updated-state)
                     updated-state)]
     (when new-state
       {:db (-> db
                (assoc-in [:lp-report-editor :lp-report :lp-report/editable-data] new-state))}))))

(rf/reg-event-fx
 ::chart-configs-save-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Chart configs save failed " resp)))

(rf/reg-event-fx
 ::save-fund-report-chart-configs
 (fn [{db :db}
      [_ fund-report-id on-success! dynamic-path new-value]]
   (let [editable-path (into [] (concat [:lp-report-editor :lp-report :lp-report/editable-data]
                                        dynamic-path))]
     {:db       (assoc-in db
                          ;; optimistic save
                          editable-path
                          new-value)
      ::ws/send {:id         :lp-report/update-chart-configs
                 :body       {:report-id       fund-report-id
                              :value-path      dynamic-path
                              :new-value       new-value}
                 :on-success [::chart-configs-save-ok on-success! editable-path]
                 :on-error   [::chart-configs-save-failed fund-report-id]}})))


(rf/reg-event-fx
 ::submitted-text-for-review-ok
 (fn [{db :db} _]
   {:db (assoc-in db
         [:lp-report-editor :lp-report :lp-report/text-status]
         :lp-report.publishing-status/pending-approval)}))

(rf/reg-event-fx
 ::submit-for-review-text-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Submit for review text failed " resp)))

(rf/reg-event-fx
 ::submitted-data-for-review-ok
 (fn [{db :db} _]
   {:db (assoc-in db
         [:lp-report-editor :lp-report :lp-report/data-status]
         :lp-report.publishing-status/pending-approval)}))

(rf/reg-event-fx
 ::submit-for-review-data-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Submit for review data failed " resp)))

(rf/reg-event-fx
 ::submit-for-review-text-confirm
 (fn [{_db :db} [_ fund-report-id recipients message]]
   {::ws/send {:id         :lp-report/submit-for-review-text
               :body       {:report-id  fund-report-id
                            :recipients recipients
                            :message    message}
               :on-success [::submitted-text-for-review-ok fund-report-id]
               :on-error   [::submit-for-review-text-failed fund-report-id]}}))


(rf/reg-event-fx
 ::submit-for-review-text
 (fn [{db :db} [_ fund-report-id]]
   {:db (-> db
            (assoc-in [::sub/fund-text-submitted?] fund-report-id))}))

(rf/reg-event-fx
 ::submit-for-review-data-confirm
 (fn [{_db :db} [_ fund-report-id recipients message]]
   {::ws/send {:id         :lp-report/submit-for-review-data
               :body       {:report-id  fund-report-id
                            :recipients recipients
                            :message    message}
               :on-success [::submitted-data-for-review-ok fund-report-id]
               :on-error   [::submit-for-review-data-failed fund-report-id]}}))

(rf/reg-event-fx
 ::submit-for-review-data
 (fn [{db :db} [_ fund-report-id]]
   {:db (-> db
            (assoc-in [::sub/fund-data-submitted?] fund-report-id))}))
(rf/reg-event-fx
 ::approve-text-ok
 (fn [{db :db} [_ _fund-report-id _]]
   {:db (assoc-in db
         [:lp-report-editor :lp-report :lp-report/text-status]
         :lp-report.publishing-status/approved)}))

(rf/reg-event-fx
 ::approve-data-ok
 (fn [{db :db} [_ _fund-report-id _]]
   {:db (assoc-in db
         [:lp-report-editor :lp-report :lp-report/data-status]
         :lp-report.publishing-status/approved)}))

(rf/reg-event-fx
 ::approve-text-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Approve text failed " resp)))

(rf/reg-event-fx
 ::approve-data-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Approve data failed " resp)))

(rf/reg-event-fx
 ::approve-text
 (fn [{_db :db} [_ fund-report-id]]
   {::ws/send {:id         :lp-report/approve-text
               :body       {:report-id fund-report-id}
               :on-success [::approve-text-ok fund-report-id]
               :on-error   [::approve-text-failed fund-report-id]}}))

(rf/reg-event-fx
 ::approve-data
 (fn [{_db :db} [_ fund-report-id]]
   {::ws/send {:id         :lp-report/approve-data
               :body       {:report-id fund-report-id}
               :on-success [::approve-data-ok fund-report-id]
               :on-error   [::approve-data-failed fund-report-id]}}))

(rf/reg-event-fx
 ::reject-text-ok
 (fn [{db :db} _]
   {:db (assoc-in db
         [:lp-report-editor :lp-report :lp-report/text-status]
         :lp-report.publishing-status/wip)}))

(rf/reg-event-fx
 ::reject-data-ok
 (fn [{db :db} _]
   {:db (assoc-in db
         [:lp-report-editor :lp-report :lp-report/data-status]
         :lp-report.publishing-status/wip)}))

(rf/reg-event-fx
 ::reject-text-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Reject text failed " resp)))

(rf/reg-event-fx
 ::reject-data-failed
 (fn [{_db :db} [_ _fund-report-id resp]]
   (js/console.log "Reject data failed " resp)))

(rf/reg-event-fx
 ::on-reject-confirmed
 (fn [{_db :db} [_ fund-report-id recipients message]]
   {::ws/send {:id         :lp-report/reject-text
               :body       {:report-id  fund-report-id
                            :recipients recipients
                            :message    message}
               :on-success [::reject-text-ok fund-report-id]
               :on-error   [::reject-text-failed fund-report-id]}}))

(rf/reg-event-fx
 ::reject-text
 (fn [{db :db} [_ fund-report-id]]
   {:db (-> db
            (assoc-in [::sub/fund-text-rejected?] fund-report-id))}))

(rf/reg-event-fx
 ::reject-data-confirm
 (fn [{_db :db} [_ fund-report-id recipients message]]
   {::ws/send {:id         :lp-report/reject-data
               :body       {:report-id  fund-report-id
                            :recipients recipients
                            :message    message}
               :on-success [::reject-data-ok fund-report-id]
               :on-error   [::reject-data-failed fund-report-id]}}))

(rf/reg-event-fx
 ::reject-data
 (fn [{db :db} [_ fund-report-id]]
   {:db (-> db
            (assoc-in [::sub/fund-data-rejected?] fund-report-id))}))

(rf/reg-event-fx
 ::close-viewer
 (fn [{db :db} [_]]
   {:db (assoc-in db sub/gathering-mode-path :report-listing)}))
